"use client"

import { createMotionComponentWithFeatures as createMotionComponent } from "./create"

/**
 * HTML components
 */
export const MotionA = /*@__PURE__*/ createMotionComponent("a")
export const MotionAbbr = /*@__PURE__*/ createMotionComponent("abbr")
export const MotionAddress = /*@__PURE__*/ createMotionComponent("address")
export const MotionArea = /*@__PURE__*/ createMotionComponent("area")
export const MotionArticle = /*@__PURE__*/ createMotionComponent("article")
export const MotionAside = /*@__PURE__*/ createMotionComponent("aside")
export const MotionAudio = /*@__PURE__*/ createMotionComponent("audio")
export const MotionB = /*@__PURE__*/ createMotionComponent("b")
export const MotionBase = /*@__PURE__*/ createMotionComponent("base")
export const MotionBdi = /*@__PURE__*/ createMotionComponent("bdi")
export const MotionBdo = /*@__PURE__*/ createMotionComponent("bdo")
export const MotionBig = /*@__PURE__*/ createMotionComponent("big")
export const MotionBlockquote =
    /*@__PURE__*/ createMotionComponent("blockquote")
export const MotionBody = /*@__PURE__*/ createMotionComponent("body")
export const MotionButton = /*@__PURE__*/ createMotionComponent("button")
export const MotionCanvas = /*@__PURE__*/ createMotionComponent("canvas")
export const MotionCaption = /*@__PURE__*/ createMotionComponent("caption")
export const MotionCite = /*@__PURE__*/ createMotionComponent("cite")
export const MotionCode = /*@__PURE__*/ createMotionComponent("code")
export const MotionCol = /*@__PURE__*/ createMotionComponent("col")
export const MotionColgroup = /*@__PURE__*/ createMotionComponent("colgroup")
export const MotionData = /*@__PURE__*/ createMotionComponent("data")
export const MotionDatalist = /*@__PURE__*/ createMotionComponent("datalist")
export const MotionDd = /*@__PURE__*/ createMotionComponent("dd")
export const MotionDel = /*@__PURE__*/ createMotionComponent("del")
export const MotionDetails = /*@__PURE__*/ createMotionComponent("details")
export const MotionDfn = /*@__PURE__*/ createMotionComponent("dfn")
export const MotionDialog = /*@__PURE__*/ createMotionComponent("dialog")
export const MotionDiv = /*@__PURE__*/ createMotionComponent("div")
export const MotionDl = /*@__PURE__*/ createMotionComponent("dl")
export const MotionDt = /*@__PURE__*/ createMotionComponent("dt")
export const MotionEm = /*@__PURE__*/ createMotionComponent("em")
export const MotionEmbed = /*@__PURE__*/ createMotionComponent("embed")
export const MotionFieldset = /*@__PURE__*/ createMotionComponent("fieldset")
export const MotionFigcaption =
    /*@__PURE__*/ createMotionComponent("figcaption")
export const MotionFigure = /*@__PURE__*/ createMotionComponent("figure")
export const MotionFooter = /*@__PURE__*/ createMotionComponent("footer")
export const MotionForm = /*@__PURE__*/ createMotionComponent("form")
export const MotionH1 = /*@__PURE__*/ createMotionComponent("h1")
export const MotionH2 = /*@__PURE__*/ createMotionComponent("h2")
export const MotionH3 = /*@__PURE__*/ createMotionComponent("h3")
export const MotionH4 = /*@__PURE__*/ createMotionComponent("h4")
export const MotionH5 = /*@__PURE__*/ createMotionComponent("h5")
export const MotionH6 = /*@__PURE__*/ createMotionComponent("h6")
export const MotionHead = /*@__PURE__*/ createMotionComponent("head")
export const MotionHeader = /*@__PURE__*/ createMotionComponent("header")
export const MotionHgroup = /*@__PURE__*/ createMotionComponent("hgroup")
export const MotionHr = /*@__PURE__*/ createMotionComponent("hr")
export const MotionHtml = /*@__PURE__*/ createMotionComponent("html")
export const MotionI = /*@__PURE__*/ createMotionComponent("i")
export const MotionIframe = /*@__PURE__*/ createMotionComponent("iframe")
export const MotionImg = /*@__PURE__*/ createMotionComponent("img")
export const MotionInput = /*@__PURE__*/ createMotionComponent("input")
export const MotionIns = /*@__PURE__*/ createMotionComponent("ins")
export const MotionKbd = /*@__PURE__*/ createMotionComponent("kbd")
export const MotionKeygen = /*@__PURE__*/ createMotionComponent("keygen")
export const MotionLabel = /*@__PURE__*/ createMotionComponent("label")
export const MotionLegend = /*@__PURE__*/ createMotionComponent("legend")
export const MotionLi = /*@__PURE__*/ createMotionComponent("li")
export const MotionLink = /*@__PURE__*/ createMotionComponent("link")
export const MotionMain = /*@__PURE__*/ createMotionComponent("main")
export const MotionMap = /*@__PURE__*/ createMotionComponent("map")
export const MotionMark = /*@__PURE__*/ createMotionComponent("mark")
export const MotionMenu = /*@__PURE__*/ createMotionComponent("menu")
export const MotionMenuitem = /*@__PURE__*/ createMotionComponent("menuitem")
export const MotionMeter = /*@__PURE__*/ createMotionComponent("meter")
export const MotionNav = /*@__PURE__*/ createMotionComponent("nav")
export const MotionObject = /*@__PURE__*/ createMotionComponent("object")
export const MotionOl = /*@__PURE__*/ createMotionComponent("ol")
export const MotionOptgroup = /*@__PURE__*/ createMotionComponent("optgroup")
export const MotionOption = /*@__PURE__*/ createMotionComponent("option")
export const MotionOutput = /*@__PURE__*/ createMotionComponent("output")
export const MotionP = /*@__PURE__*/ createMotionComponent("p")
export const MotionParam = /*@__PURE__*/ createMotionComponent("param")
export const MotionPicture = /*@__PURE__*/ createMotionComponent("picture")
export const MotionPre = /*@__PURE__*/ createMotionComponent("pre")
export const MotionProgress = /*@__PURE__*/ createMotionComponent("progress")
export const MotionQ = /*@__PURE__*/ createMotionComponent("q")
export const MotionRp = /*@__PURE__*/ createMotionComponent("rp")
export const MotionRt = /*@__PURE__*/ createMotionComponent("rt")
export const MotionRuby = /*@__PURE__*/ createMotionComponent("ruby")
export const MotionS = /*@__PURE__*/ createMotionComponent("s")
export const MotionSamp = /*@__PURE__*/ createMotionComponent("samp")
export const MotionScript = /*@__PURE__*/ createMotionComponent("script")
export const MotionSection = /*@__PURE__*/ createMotionComponent("section")
export const MotionSelect = /*@__PURE__*/ createMotionComponent("select")
export const MotionSmall = /*@__PURE__*/ createMotionComponent("small")
export const MotionSource = /*@__PURE__*/ createMotionComponent("source")
export const MotionSpan = /*@__PURE__*/ createMotionComponent("span")
export const MotionStrong = /*@__PURE__*/ createMotionComponent("strong")
export const MotionStyle = /*@__PURE__*/ createMotionComponent("style")
export const MotionSub = /*@__PURE__*/ createMotionComponent("sub")
export const MotionSummary = /*@__PURE__*/ createMotionComponent("summary")
export const MotionSup = /*@__PURE__*/ createMotionComponent("sup")
export const MotionTable = /*@__PURE__*/ createMotionComponent("table")
export const MotionTbody = /*@__PURE__*/ createMotionComponent("tbody")
export const MotionTd = /*@__PURE__*/ createMotionComponent("td")
export const MotionTextarea = /*@__PURE__*/ createMotionComponent("textarea")
export const MotionTfoot = /*@__PURE__*/ createMotionComponent("tfoot")
export const MotionTh = /*@__PURE__*/ createMotionComponent("th")
export const MotionThead = /*@__PURE__*/ createMotionComponent("thead")
export const MotionTime = /*@__PURE__*/ createMotionComponent("time")
export const MotionTitle = /*@__PURE__*/ createMotionComponent("title")
export const MotionTr = /*@__PURE__*/ createMotionComponent("tr")
export const MotionTrack = /*@__PURE__*/ createMotionComponent("track")
export const MotionU = /*@__PURE__*/ createMotionComponent("u")
export const MotionUl = /*@__PURE__*/ createMotionComponent("ul")
export const MotionVideo = /*@__PURE__*/ createMotionComponent("video")
export const MotionWbr = /*@__PURE__*/ createMotionComponent("wbr")
export const MotionWebview = /*@__PURE__*/ createMotionComponent("webview")

/**
 * SVG components
 */
export const MotionAnimate = /*@__PURE__*/ createMotionComponent("animate")
export const MotionCircle = /*@__PURE__*/ createMotionComponent("circle")
export const MotionDefs = /*@__PURE__*/ createMotionComponent("defs")
export const MotionDesc = /*@__PURE__*/ createMotionComponent("desc")
export const MotionEllipse = /*@__PURE__*/ createMotionComponent("ellipse")
export const MotionG = /*@__PURE__*/ createMotionComponent("g")
export const MotionImage = /*@__PURE__*/ createMotionComponent("image")
export const MotionLine = /*@__PURE__*/ createMotionComponent("line")
export const MotionFilter = /*@__PURE__*/ createMotionComponent("filter")
export const MotionMarker = /*@__PURE__*/ createMotionComponent("marker")
export const MotionMask = /*@__PURE__*/ createMotionComponent("mask")
export const MotionMetadata = /*@__PURE__*/ createMotionComponent("metadata")
export const MotionPath = /*@__PURE__*/ createMotionComponent("path")
export const MotionPattern = /*@__PURE__*/ createMotionComponent("pattern")
export const MotionPolygon = /*@__PURE__*/ createMotionComponent("polygon")
export const MotionPolyline = /*@__PURE__*/ createMotionComponent("polyline")
export const MotionRect = /*@__PURE__*/ createMotionComponent("rect")
export const MotionStop = /*@__PURE__*/ createMotionComponent("stop")
export const MotionSvg = /*@__PURE__*/ createMotionComponent("svg")
export const MotionSymbol = /*@__PURE__*/ createMotionComponent("symbol")
export const MotionText = /*@__PURE__*/ createMotionComponent("text")
export const MotionTspan = /*@__PURE__*/ createMotionComponent("tspan")
export const MotionUse = /*@__PURE__*/ createMotionComponent("use")
export const MotionView = /*@__PURE__*/ createMotionComponent("view")
export const MotionClipPath = /*@__PURE__*/ createMotionComponent("clipPath")
export const MotionFeBlend = /*@__PURE__*/ createMotionComponent("feBlend")
export const MotionFeColorMatrix =
    /*@__PURE__*/ createMotionComponent("feColorMatrix")
export const MotionFeComponentTransfer = /*@__PURE__*/ createMotionComponent(
    "feComponentTransfer"
)
export const MotionFeComposite =
    /*@__PURE__*/ createMotionComponent("feComposite")
export const MotionFeConvolveMatrix =
    /*@__PURE__*/ createMotionComponent("feConvolveMatrix")
export const MotionFeDiffuseLighting =
    /*@__PURE__*/ createMotionComponent("feDiffuseLighting")
export const MotionFeDisplacementMap =
    /*@__PURE__*/ createMotionComponent("feDisplacementMap")
export const MotionFeDistantLight =
    /*@__PURE__*/ createMotionComponent("feDistantLight")
export const MotionFeDropShadow =
    /*@__PURE__*/ createMotionComponent("feDropShadow")
export const MotionFeFlood = /*@__PURE__*/ createMotionComponent("feFlood")
export const MotionFeFuncA = /*@__PURE__*/ createMotionComponent("feFuncA")
export const MotionFeFuncB = /*@__PURE__*/ createMotionComponent("feFuncB")
export const MotionFeFuncG = /*@__PURE__*/ createMotionComponent("feFuncG")
export const MotionFeFuncR = /*@__PURE__*/ createMotionComponent("feFuncR")
export const MotionFeGaussianBlur =
    /*@__PURE__*/ createMotionComponent("feGaussianBlur")
export const MotionFeImage = /*@__PURE__*/ createMotionComponent("feImage")
export const MotionFeMerge = /*@__PURE__*/ createMotionComponent("feMerge")
export const MotionFeMergeNode =
    /*@__PURE__*/ createMotionComponent("feMergeNode")
export const MotionFeMorphology =
    /*@__PURE__*/ createMotionComponent("feMorphology")
export const MotionFeOffset = /*@__PURE__*/ createMotionComponent("feOffset")
export const MotionFePointLight =
    /*@__PURE__*/ createMotionComponent("fePointLight")
export const MotionFeSpecularLighting =
    /*@__PURE__*/ createMotionComponent("feSpecularLighting")
export const MotionFeSpotLight =
    /*@__PURE__*/ createMotionComponent("feSpotLight")
export const MotionFeTile = /*@__PURE__*/ createMotionComponent("feTile")
export const MotionFeTurbulence =
    /*@__PURE__*/ createMotionComponent("feTurbulence")
export const MotionForeignObject =
    /*@__PURE__*/ createMotionComponent("foreignObject")
export const MotionLinearGradient =
    /*@__PURE__*/ createMotionComponent("linearGradient")
export const MotionRadialGradient =
    /*@__PURE__*/ createMotionComponent("radialGradient")
export const MotionTextPath = /*@__PURE__*/ createMotionComponent("textPath")
